import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=d9606b48&"
import script from "./Exhibition.vue?vue&type=script&lang=js&"
export * from "./Exhibition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports